import React from "react";
import OverviewSection from "../../components/AboutUs/Overview/OverviewSection.tsx";
import MetaComponent from "../../components/CommonComponents/MetaComponent.tsx";

const OverView: React.FC = () => {
  return (
    <div>
      <MetaComponent
        title="About Aptech Limited | Pioneer in Vocational and Skill-based Training provider in India"
        desc="Aptech Limited is a pioneer in vocational and skill-based training business in India with a significant global presence. It helps students and professionals build careers in animation, VFX, beauty and wellness, IT, Aviation."
        keywords="Vocational training business, vocational training provider, Aptech limited, vocational training programs"
      />
      <OverviewSection />
    </div>
  );
}

export default OverView;
